/* eslint-disable */
import { Button, Menu, MenuButton, MenuItemOption, MenuList, MenuOptionGroup, useDisclosure, Box, Flex } from '@chakra-ui/core';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FiGlobe } from 'react-icons/fi';
import colors from '../../styles/colors';

export const LanguageSwitcher = (): JSX.Element => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [language, setLanguage] = useState<string>('en');
  const { t, i18n } = useTranslation();
  const { isOpen, onOpen, onClose } = useDisclosure();

  const onLanguageChange = (language: string) => {
    /* istanbul ignore next */
    if (typeof window !== 'undefined') {
      localStorage.setItem('language', language);
    }
    setLanguage(language);
    i18n.changeLanguage(language);
  };

  useEffect(() => {
    const storedLanguage = localStorage.getItem('language');
    setLanguage(storedLanguage ?? 'en');
  }, []);

  return (
    <Menu isLazy id="languagePickerMenu" isOpen={isOpen}>
      <MenuButton
        as={Button as any}
        variant="ghost"
        data-testid="languagePickerMain"
        onMouseEnter={onOpen}
        onMouseLeave={onClose}
        color={colors.white}
        // Force the button to be a square shape on mobile
        px={{ base: 0, md: 4 }}
        minW={{ base: '40px', md: 'auto' }}
      >
        <Flex alignItems="center" justifyContent="center">
          <FiGlobe />

          {/* Show text only on medium screens and up */}
          <Box as="span" display={{ base: 'none', md: 'inline' }} ml={2}>
            {t('language')}
          </Box>
        </Flex>
      </MenuButton>
      <MenuList border="none" onMouseEnter={onOpen} onMouseLeave={onClose}>
        <MenuOptionGroup
          value={i18n.language === 'en' ? 'en' : 'fr'}
          onChange={(value) => {
            /* istanbul ignore next */
            if (Array.isArray(value)) {
              onLanguageChange(value[0]);
            } else {
              onLanguageChange(value);
            }
          }}
        >
          <MenuItemOption data-testid="languagePickerEn" value="en">
            English
          </MenuItemOption>
          <MenuItemOption data-testid="languagePickerFr" value="fr">
            Français
          </MenuItemOption>
        </MenuOptionGroup>
      </MenuList>
    </Menu>
  );
};
